import { render, staticRenderFns } from "./editPicProfile.vue?vue&type=template&id=7274fc76&scoped=true"
import script from "./editPicProfile.vue?vue&type=script&lang=js"
export * from "./editPicProfile.vue?vue&type=script&lang=js"
import style0 from "./editPicProfile.vue?vue&type=style&index=0&id=7274fc76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7274fc76",
  null
  
)

export default component.exports